// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-station-content[data-v-6b898144]{position:relative}.download-svg-css[data-v-6b898144]{width:1280px;height:768px;z-index:-1;position:absolute;top:50px}", ""]);
// Exports
module.exports = exports;
